import React, {Component} from 'react';
import $ from 'jquery';
import {withRouter} from 'react-router-dom';
import Loading from './Loading';
import Env from '../model/Env';
import Validator from '../model/Validator';
import {FormRecommend} from '../model/Helper';

class FormFinal extends Component {

    constructor(props){
        super(props);
        this.state = {
            fn: props.fn,
            dn: props.dn,
            fullname: "",
            destinationEmail: "",
            contract_html: props.contract_html,
            formPath: props.formPath,
            formError: [],
            details: this.props.details,
            recommend: FormRecommend(this.props.details.seller || [], this.props.details.buyer || [])       
        }
    }

    componentWillMount(){
        /**
         * Removing file for premium dl if any
         */
        localStorage.removeItem("premium-dl");
    }

    sendToApi(e){
        e.preventDefault();

        $(".loading").removeClass("d-none");

        let fd = new FormData();
        fd.append("html", this.state.contract_html);
        fd.append("fullname", this.state.fullname);
		fd.append("filename", this.state.fn);
        fd.append("docname", this.state.dn);
        fd.append("email_recipient", this.state.destinationEmail);
        fd.append("recommend", JSON.stringify(this.state.recommend));

        fetch(Env.BASE_API+"/?task=generate-pdf",{
			method: "POST",
			body: fd
		})
			.then(resp=>resp.json())
			.then((data)=>{
				//console.log(data)
				if(data.ERR === 0) {

                    console.log("Doc name:", this.state.dn);

                    // Redirecting to TY pages
                    if(this.state.dn==="Contract to Sell"){

                        window.location.href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=MYND9KGJ88SDG";

                        /**
                         * Send to local storage temporarily
                         */
                        localStorage.setItem("premium-dl", this.state.fn);

                    } else if(this.state.dn==="Deed of Absolute Sale"){
                        
                        window.location.href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=PV48J93E2XDAE";

                        /**
                         * Send to local storage temporarily
                         */
                        localStorage.setItem("premium-dl", this.state.fn);

                    } else if(this.state.dn==="Real Estate Mortgage") {
                        window.location.href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=M9SKEEJLF776Y";

                        /**
                         * Send to local storage temporarily
                         */
                        localStorage.setItem("premium-dl", this.state.fn);

                    } else {
                        this.props.history.push({
                            pathname: "ty",
                            state: {
                                fullname: this.state.fullname,
                                destinationEmail: this.state.destinationEmail,
                                filename: this.state.fn,
                                dn: this.state.dn,
                                fallback: this.state.formPath,
                                details: this.state.details
                            }
                        });
                        
                        $.get(Env.BASE_PDF+"/"+this.state.fn+".pdf",()=>{
                            window.location.assign(Env.BASE_PDF+"/"+this.state.fn+".pdf");
                        });
                    }
					
				} else {
					console.log("API call fail.");
				}
			});

    }

    handleChange(event) {
		const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

	    this.setState({
			[name]: value
		}, ()=>{
			this.errorHandle();
		});
    }
    
    errorHandle(callback = null) {
        let errorArray = [];

        if(!this.state.fullname) {
            let err = {
                "message": `Please enter fullname.`
            }
            errorArray.push(err);
        }
        
        if(Validator.email.test(this.state.destinationEmail)===false) {
            let err = {
                "message": `Enter valid email address.`
            }
            errorArray.push(err);
        }

        //console.log(Validator.email.test(this.state.destinationEmail))

        this.setState({
            formError: errorArray
        },(i)=>{
            this.checkCompleteness();
        })

    }

    checkCompleteness() {
		if(this.state.formError.length>0) {
            $(".download").removeClass("btn-success").prop("disabled", true);
		} else {
            $(".download").addClass("btn-success").prop("disabled", false);
		}			
    }

    isFreeContract(subj){
        let status = false;
        let freeContracts=["Board Resolution (to sell)", "Earnest Money Agreement", "Option Contract", "Secretary's Certificate (to sell)", "Special Power of Attorney (to sell)"];
        for(let i=0; i<=freeContracts.length; i++){
            // console.log(freeContracts[i]+"==="+subj)
            if(freeContracts[i]===subj){
                // console.log(true)
                status = true;
                break;
            }
        }
        return status;
    }

    render(){
        return(
            <div>
                <Loading />
                
                <h5>Your {this.props.dn} is ready.</h5>
                <p>Next, enter your name and email then click the download button below to get your custom {this.props.dn} (PDF format).</p>
                <form onSubmit={this.sendToApi.bind(this)}>
                    <div className="form-group">
                        <input className="form-control form-control-lg" name="fullname" type="text" placeholder="Please enter your name" onChange={this.handleChange.bind(this)} value={this.state.fullname} required />
                    </div>
                    <div className="form-group">
                        <input className="form-control form-control-lg" name="destinationEmail" type="email" placeholder="Please enter your email" onChange={this.handleChange.bind(this)} value={this.state.destinationEmail} required />
                    </div>
                    <div className={`alert alert-warning ${this.state.formError.length>0?``:`d-none`}`}>
                        {
                            this.state.formError.map((el, i) => {
                                return(
                                    <div className="text-left" key={i}>{el.message}</div>
                                )
                            })
                        }
                    </div>
                    <button className="btn btn-secondary p-3 w-100 download" disabled="true" >DOWNLOAD YOUR {this.isFreeContract(this.state.dn)?`FREE `:``}CONTRACT</button>

                    <br />
                    <br />

                    {
                        !this.isFreeContract(this.state.dn)?
                        <p><u>{this.state.dn} is <strong>FREE</strong> for a limited time only</u>.</p>:
                        ``
                    }
                </form>
            </div>
        )
    }
}

export default withRouter(FormFinal);


// WEBPACK FOOTER //
// ./src/view/FormFinal.js